// features/perfil/api/perfil.api.js
// Capa de API para perfil del usuario autenticado.
//
// profileService.js:
//   GET  /api/profile/me         → getMe
// usuario.resource.js:
//   PUT  /api/user/me            → updateMe
//   PUT  /api/me/password        → changePassword  (usa baseURL, no this.api)

import { api } from '../../../api/client';

export const profileApi = {
  /** Obtiene el perfil del usuario autenticado */
  getMe: () =>
    api.get('/profile/me'),

  /**
   * Actualiza datos del perfil
   * @param {object} data
   */
  updateMe: (data) =>
    api.put('/profile/me', data),

  /**
   * Cambia la contraseña del usuario autenticado
   * @param {{ currentPassword: string, newPassword: string }} data
   */
  changePassword: (data) =>
    api.put('/profile/me/password', data),
};
